<div class="navigate-store">
    <p>Processing....</p>
</div>